<template>
  <div class="main bg--light">
    <template v-if="isAuthenticated">
      <Navbar />
      <Sidebar />
    </template>
    <router-view class="bg--light" :key="$route.fullPath"/>
  </div>
</template>

<script>
// eslint-disable-next-lines
import Navbar from "./components/navbar/index";
import Sidebar from "./components/sidebar/index";
import { syncAppThemeForSession } from "./utils/taskDashboardThemes";
import moment from "moment";

const DATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

export default {
  components: {
    Navbar,
    Sidebar
  },
  data() {
    return {
      currentDay: moment().format("YYYY-MM-DD")
    };
  },
  computed: {
    isAuthenticated() {
      return this.$route.meta.requiresAuth;
    }
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler() {
        syncAppThemeForSession();
      }
    }
  },
  mounted() {
    syncAppThemeForSession();

    // If the workspace is left open overnight, reload once the calendar
    // day changes so the session/data restart fresh each morning instead
    // of running on stale date-dependent state.
    this.dateCheckIntervalId = setInterval(() => {
      const today = moment().format("YYYY-MM-DD");
      if (today !== this.currentDay && this.isAuthenticated) {
        window.location.reload();
      }
    }, DATE_CHECK_INTERVAL_MS);
  },
  beforeDestroy() {
    clearInterval(this.dateCheckIntervalId);
  }
};
</script>

<style lang="scss">
@import "./scss/main/custom.scss";
* {
  font-family: "Graphik Regular";
}
html,
body {
  min-height: 100vh !important;
  height: 100% !important;
}
body:not(.app-themed) {
  background-color: #f6f9fc !important;
}
.main {
  height: 100%;
}
</style>
